import React from 'react';
import { Content, Portal, Root, Trigger, Close } from '@radix-ui/react-popover';
import { Icon, IconsEnum } from 'components/Icons';

import classNames from 'classnames';
import styles from './CarrelloPopoverMenu.module.scss';
import useWindowSize from 'hooks/useWindowSize';

export type CarrelloPopoverMenuProps = {
  children: React.ReactNode;
  containerClassname?: string;
};

export const CarrelloPopoverMenu = ({ children, containerClassname }: CarrelloPopoverMenuProps) => {
  const { isMobile } = useWindowSize();

  return (
    <div className={classNames(styles.container, containerClassname)}>
      <Root>
        <Trigger asChild>
          <button type="button" className={styles.triggerBtn}>
            <Icon color="var(--color-on-bg-secondary)" className={styles.icon} iconId={IconsEnum.GEAR} />
          </button>
        </Trigger>
        <Portal>
          {/* TODO: check -> className={styles.portal}> -> Property 'className' does not exist on type 'IntrinsicAttributes & PopoverPortalProps & { children?: ReactNode; } */}
          <Content className={styles.content} sideOffset={4} side={isMobile ? 'top' : 'bottom'}>
            <Close>{children}</Close>
          </Content>
        </Portal>
      </Root>
    </div>
  );
};